export enum ToggleSize {
    LARGE = 'large',
    MEDIUM = 'medium',
    SMALL = 'small',
}
